import { EVENT } from '../constants'
import { GA4Event, GA4GeneralProps } from '../GA4Event'

export interface GA4ViewItemListRenderProps {
  item_variant: string | null // this field is similar to option
  item_brand: string | null // this field is similar to component_rendered_class
  item_name: string | null // this field is similar to component_rendered_name
  item_id: string | null // this field is similar to resource_id_rendered
}

interface Properties extends GA4GeneralProps {
  renders?: GA4ViewItemListRenderProps[] | null
  selectedOption?: string | null
  _clear?: boolean | null
}

/** To launch component_render event, use this constant because is necessary the event be a VIEW_LIST_ITEM */
export class GA4ViewItemListEvent extends GA4Event {
  ga4_renders?: GA4ViewItemListRenderProps[] | null
  ga4_selected_option?: string | null
  _clear?: boolean | null

  constructor({
    renders = null,
    selectedOption = null,
    _clear = true,
    ...generalProps
  }: Properties) {
    super({ event: EVENT.VIEW_ITEM_LIST, ...generalProps })

    this._clear = _clear
    this.ga4_selected_option = selectedOption
    this.ga4_renders = renders
      ? renders.map((item) => ({
          item_variant: item.item_variant,
          item_brand: item.item_brand,
          item_name: item.item_name,
          item_id: item.item_id,
        }))
      : null
  }
}
